export default __webpack_public_path__ + "static/jan21-4e675fccf9c9c349e1062747e4b55688.png";